import { Component, OnInit, Input } from '@angular/core';
import { ProductPage } from 'src/app/assabil-kernel/models/entities/control-tables/product-page';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';

@Component({
  selector: 'product-entry',
  templateUrl: './product-entry.component.html',
  styleUrls: ['./product-entry.component.scss']
})
export class ProductEntryComponent implements OnInit {

    constructor(
      protected leanUtilsService : LeanUtilsService
    ) { }

    myDecimal : number ;
    myDecimal2 : number;

    @Input() productPages     : ProductPage[] = [];
    @Input() enteredOnly      : boolean = false;
    @Input() editMode         : boolean = true;
    @Input() columns          : [];

    
    @Input() purchasePacking  : boolean = false;
    @Input() packing          : string = 'L';


    @Input() palletSymbol    : string = '';// = 'p';
    @Input() packSymbol      : string = '';// = 'c';
    @Input() unitSymbol      : string = '';// = 'u';
    @Input() noStockData     : boolean  = false;

    ngOnInit() {
    }

    showProductPage(productPage : ProductPage) : boolean {
      let result : boolean = false;
      for(let product of productPage.products){
          if (this.showProduct(product)) {
            result = true;
            break;
          }
      }
      return result;
    }

    showProduct(product : Product) : boolean{
      if (! this.enteredOnly) return true;

      for (let q of product.quantityL) {
        if (q) return true;
      } 

      for (let q of product.quantityP) {
        if (q) return true;
      } 
      for (let q of product.quantityU) {
        if (q) return true;
      } 

      return false;
    }
      
    getPurchasePacks(quantity : number, product : Product) : string { 
      if (! this.showStockInPurchasePacks()) return '';
      let pallets  = Math.floor(quantity / product.purchasePacking); 
      if (!pallets) return '.';
      return pallets + this.palletSymbol;
    }

    getPacks(quantity : number, product : Product) : string { 
      let packs : number;
      if (! this.showStockInPurchasePacks()) {
        packs =  Math.floor(quantity / this.getPacking(product)); 
      } else {
         packs = Math.floor( (quantity % product.purchasePacking) / this.getPacking(product));
      }
      if (!packs) return '.'; 
      return packs + this.packSymbol;
    }
    getUnits(quantity : number, product : Product) : string { 
      let units : number;
      if (! this.showStockInPurchasePacks()) {
        units =  quantity % this.getPacking(product);
      } else {
        let pallets = Math.floor(quantity / product.purchasePacking); 
        let packs   = Math.floor( (quantity % product.purchasePacking) / this.getPacking(product)); 
        units       = quantity -  (pallets *  product.purchasePacking) -  (packs * this.getPacking(product));
      }
      if (!units) return '.'; 
      return units + this.unitSymbol;
    }

    getPacking(product : Product) : number{
      let res : number;
      if (this.packing == 'L') res = product.loadPacking; else res = product.salesPacking;
      return res;
    }
 
   addSymbol(q : number, s : string) : string {
     if (!q) return '.';
      return q + s;
   } 

   getProductPackings(product : Product) : string{
    return product.purchasePacking + '-'+ this.getPacking(product);
  }

  showStockInPurchasePacks() : boolean {
    return this.leanUtilsService.showStockInPurchasePacks;
  }

  checkNumber(product : Product, event : any) : boolean{
   console.log(product);
    return ( event.charCode >= 48 ) && ( event.charCode <= 57 )
  }
}

